<template>
  <div class="client-download-container">
    <div class="download-methods-box">
      <div class="close-area" style="text-align: right">
        <em class="el-icon-close close" @click="backHandler"></em>
      </div>
      <div class="title">{{ $t('menu')['客户端下载'] }}</div>
      <div class="methods">
        <div class="wechat">
          <img src="../../src/assets/image/wx-code.png" alt="" />
          <div class="msg">{{ $t('wx') }}</div>
        </div>
        <div class="android">
          <img src="../../src/assets/image/android.png" alt="" />
          <div class="msg">{{ $t('android') }}</div>
        </div>
      </div>

      <div class="back-area">
        <el-button type="primary" @click="backHandler">{{ $t('返回') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    backHandler() {
      this.$router.go(-1);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.client-download-container {
  color: #01cad8;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  background-image: url('~@/assets/image/bg.png');

  .download-methods-box {
    padding: 10px;
    height: 320px;
    width: 700px;
    border-radius: 10px;
    background-color: #20293a;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .close-area {
      cursor: pointer;
      .close {
        font-size: 20px !important;
      }
    }
    .title {
      text-align: center;
      font-size: 25px;
    }

    .methods {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .wechat,
      .android {
        text-align: center;
        img {
          width: 130px;
          height: 130px;
        }

        .msg {
          text-align: center;
          margin-top: 10px;
          font-size: 15px;
        }
      }
    }
    .back-area {
      margin-top: 10px;
      text-align: right;
    }
  }
}
</style>
